module.exports = __webpack_public_path__ + "static/media/login-bg.53025887.jpeg";